export class QueryModelUpdated {
  public Id: string;
  public Message: string;

  constructor(id: string, message: string) {
    this.Id = id;
    this.Message = message;
  }
}
